<template>
  <header class="header-global py-5 bg-primary">
    <b-navbar toggleable="md" fixed="top" sticky type="dark">
      <b-navbar-brand href="/"><img src="../../public/logo/white.png" alt="logo" /></b-navbar-brand>

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse v-if="IsLoggedIn" id="nav-collapse" is-nav>
        <b-navbar-nav>
          <b-nav-item href="/balancereport">Balance</b-nav-item>
          <b-nav-item v-if="IscompanyAdmin" href="/developers">Developers</b-nav-item>
          <b-nav-item href="/transactionstatus">Transaction Status</b-nav-item>
          <b-nav-item href="/invoicereport">Invoice</b-nav-item>
          <b-nav-item href="/productreport">Product Stats</b-nav-item>
          <b-nav-item href="/walletreport">Accounts</b-nav-item>
        </b-navbar-nav>

        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto">
          <b-nav-item-dropdown right>
            <!-- Using 'button-content' slot -->
            <template #button-content>
              <em>{{ GetLoggedInUser }}</em>
            </template>
            <b-dropdown-item v-if="IscompanyAdmin" href="/companyuser">Add Company User</b-dropdown-item>
            <b-dropdown-item href="/changepassword">Change Password</b-dropdown-item>
            <b-dropdown-item @click="SignOut" href="#">Sign Out</b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </header>
</template>
<script>
import BaseNav from "@/components/BaseNav";
import BaseDropdown from "@/components/BaseDropdown";
import CloseButton from "@/components/CloseButton";
import { userAuth } from "../services/security";
import config from "@/settings/config.js";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  components: {
    BaseNav,
    CloseButton,
    BaseDropdown,
    Loading,
  },
  data: function () {
    return {
      isLoading: true,
      fullPage: true,
    };
  },
  computed: {
    IsLoggedIn: function () {
      return userAuth.data().user.isAuthenticated;
    },
    GetLoggedInUser: function () {
      return userAuth.GetUserName();
    },
    IscompanyAdmin: function () {
      const role = userAuth.getAuthorised();
      let hasRole = false;
      if (role) {
        if (Array.isArray(role))
          hasRole = role.includes("Company_admin");
        else
          hasRole = role === "Company_admin";
      }
      return hasRole;
    }
  },
  methods: {
    SignIn: async function () {
      await userAuth.signIn("/users");
    },
    SignOut: async function () {
      await userAuth.SignOut();
    },
  },
};
</script>
<style></style>